/* eslint-disable no-console */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-underscore-dangle */

import { MLPortalSettingsService } from "gw-capability-quoteandbind";
import UserService from './../../gw-capability-gateway/services/UserService';
import MLBundleService from "./MLBundleService";

const SESSION_AGENCY_KEY = 'agencyCodeEligible'
const SESSION_RISK_STATE_KEY = 'bundleRiskStates'


const _checkIsAgencyCodeEligible = (enabledAgencyCodes, agencyCode) => {
    
    if (!agencyCode || !enabledAgencyCodes) {
        return false;
    }

    if (enabledAgencyCodes?.includes(agencyCode)) {
        console.log('Landing Page - AgencyCode is eligible', enabledAgencyCodes, agencyCode)
        return true;
    }

    console.log('Landing Page - AgencyCode is not eligible', enabledAgencyCodes, agencyCode)
    return false;
}

const _agencyIsEnabled = async (enabledAgencyCodes, authHeader) => {

    // check if we have already evaluated the agency code and saved results in session storage (to prevent the need for a getCurrentUser API call) for this user
    const agencyCodeEligableStorage = sessionStorage.getItem(SESSION_AGENCY_KEY);
    if (agencyCodeEligableStorage){
        console.log('LandingPage - AgencyCode was in storage as ', agencyCodeEligableStorage)
        return agencyCodeEligableStorage === 'true';
    }

    // no match in session storage.  Fetch the user info and check if the agency code is eligible, then save results in session storage
    if (enabledAgencyCodes){
        const userInfo = await UserService.getCurrentUser(authHeader)
        const agencyCode = userInfo.primaryProducerCode_ML?.group_ML?.agentID
        const agencyCodeEligible = _checkIsAgencyCodeEligible(enabledAgencyCodes, agencyCode);
        
        console.log('LandingPage - Saving to sessionStorage - AgencyCode is ', agencyCode, ' and is eligible ', agencyCodeEligible)
        sessionStorage.setItem(SESSION_AGENCY_KEY, agencyCodeEligible);
        return agencyCodeEligible;
    }

    return false
}

const _riskStateIsEnabled = async (quoteNumber, enabledStates, authHeader) => {

    // check if we have already evaluated the risk states and saved results in session storage (to prevent the need for a getBridgedQuoteSummaries API call) for this bundle
    const storedRisStateInfo = sessionStorage.getItem(SESSION_RISK_STATE_KEY);
    if (storedRisStateInfo){
        const storedRiskStateData = JSON.parse(storedRisStateInfo)
        if (storedRiskStateData?.quoteNumbers?.includes(quoteNumber)){
            console.log(`LandingPage - Risk States for quote ${quoteNumber} is in storage as `, storedRiskStateData.riskStatesEligible)
            return storedRiskStateData.riskStatesEligible
        }
    }

    
    // No match in session storage.  Fetch the bundle summaries and check if any of the bridged quotes are in an eligible state, then save results in session storage
    console.log('LandingPage - Risk States for quote ', quoteNumber, ' not in storage')
    if (enabledStates && quoteNumber && enabledStates.length > 0) {
        const bundleSummaries = await MLBundleService.getBridgedQuoteSummaries(quoteNumber, authHeader)
        if (bundleSummaries && bundleSummaries.jobSummaries) {

            const quoteNumbers = []
            const riskStates = []
            bundleSummaries.jobSummaries.forEach((jobSummary) => {
                quoteNumbers.push(jobSummary.jobNumber)
                if (jobSummary.isCompRaterRequest_ML){
                    riskStates.push(jobSummary.baseState)
                }
            });

            const isEligible = riskStates.some((riskState) => enabledStates.includes(riskState))
            sessionStorage.setItem(SESSION_RISK_STATE_KEY, JSON.stringify({quoteNumbers, riskStatesEligible: isEligible}))
            console.log('LandingPage - saving to sessionStorage -  Risk States info for quotes ', quoteNumber,  isEligible)
            return isEligible
        }
    }


    console.log('LandingPage - Default case - Not eligible')
    sessionStorage.setItem(SESSION_RISK_STATE_KEY, JSON.stringify({quoteNumber, riskStatesEligible: false}))
    return false;
}

const _checkIsCRWizardEligible = async (quoteNumber, authHeader = {}, isGCS = false) => {
    try{

        const settingsResp = await MLPortalSettingsService.getSettings(authHeader)
        if (!settingsResp) {
            return false
        }

        const { landingPageSettings } = settingsResp;
                
        
        if (!landingPageSettings) {
            // We don't have the settings, so we can't determine if the user is eligible -- not eligible
            return false;
        }
    
        const {enableLandingPage, enableLandingPageCountrywide, enabledAgencyCodes, enabledStates} = landingPageSettings;
    
        
        if (enableLandingPage !== true){
            // Landing page is disabled globally - Nobody is Eligible
            console.log('Landing page - disabled globally')
            return false
        }

        if(isGCS && enabledAgencyCodes?.includes("GCS")) {
            return false
        }
    
        
        if (enableLandingPageCountrywide === true) {
            // Landing page is enabled countrywide - Everybody is eligible
            console.log('Landing page - enabled countrywide')
            return true                
        }

        if (enabledAgencyCodes &&  (await _agencyIsEnabled(enabledAgencyCodes, authHeader)) === true ){
            // Agency is eligible
            return true;
        }   

        if (enabledStates &&  (await _riskStateIsEnabled(quoteNumber, enabledStates, authHeader)) === true ) {
            // One of the bridged quotes in the bundle is in an eligible state
            return true;
        }

        return false;

    } catch(error){
        console.error(error);
        return false;
    }
}

const _checkIsGroupEnabled = async (policyState, authHeader = {}) => {
    try {

        const settingsResp = await MLPortalSettingsService.getSettings(authHeader);
        if (!settingsResp) {
            return false
        }

        const { groupAffiliationSettings } = settingsResp;
        const { enableGroupScreen, enabledStates, userHasGroupAccess } = groupAffiliationSettings;

        return enableGroupScreen && userHasGroupAccess && enabledStates && enabledStates.indexOf(policyState)>-1;
    } catch(error){
        console.error(error);
        return false;
    }
}

export default {
    checkIsCRWizardEligible: _checkIsCRWizardEligible,
    checkIsGroupEnabled: _checkIsGroupEnabled
}